import { shop } from "@/repositories/shop";
import { useQuery } from "react-query";

export const shopQuery = (shopId: string) => ({
  queryKey: ["shops", shopId],
  queryFn: () => shop.get(shopId),
  refetchOnWindowFocus: false,
});

export const useShopQuery = (shopId: string) => {
  return useQuery(shopQuery(shopId));
};
